/* eslint-disable no-shadow */
import classNames from 'classnames';
import React, { FC } from 'react';
import { usePathPrefix } from '../../../../../constants/hooks';
import { isTooDark } from '../../../../../utils/color';
import { Breadcrumbs } from '../../../../common/Breadcrumbs';
import root from '../../../styles.module.scss';
import { CaseTitleTerm } from '../../CaseTitleTerm';
import styles from './styles.module.scss';

type IProps = {
  title: string;
  subtitle: string;
  termsBackground: string;
  terms: {
    image: string;
    title: string;
    text: string;
  }[];
  afterTermsDescription?: string;
  mainBackroundColor: string;
  isDarkMainBackground?: boolean;
} & (
  | { description: string; descriptionParagraphs?: never }
  | { description?: never; descriptionParagraphs: string[] }
);

const CaseTitleWithDeviceLeft: FC<IProps> = ({
  title,
  subtitle,
  description,
  descriptionParagraphs,
  terms,
  afterTermsDescription,
  termsBackground,
  mainBackroundColor,
  isDarkMainBackground,
}) => {
  const prefix = usePathPrefix();
  const isColorDark =
    isDarkMainBackground != null
      ? isDarkMainBackground
      : isTooDark(mainBackroundColor);
  // TODO: Need added color props if added custom color on template
  const fontColor = isColorDark ? '#ffffff' : '#272727';

  return (
    <>
      <div className={classNames(root.breadcrumbs, styles.breadcrumbs)}>
        <Breadcrumbs title={title} textColor={fontColor} />
      </div>

      <h1 style={{ color: fontColor }}>{subtitle}</h1>

      {description ? (
        <span style={{ color: fontColor }}>{description}</span>
      ) : (
        descriptionParagraphs &&
        descriptionParagraphs.map((paragraph, i) => (
          <p
            /* eslint-disable react/no-array-index-key */
            key={i}
            className={styles.paragraph}
            style={{ color: fontColor }}
            dangerouslySetInnerHTML={{ __html: paragraph }}
          />
        ))
      )}

      <div className={styles.break} />

      {terms &&
        terms.map(({ image, title, text }, i) => (
          <CaseTitleTerm
            key={title}
            image={`${prefix}${image}`}
            title={title}
            text={text}
            backgroundColor={termsBackground}
            textColor={fontColor}
          />
        ))}

      <span style={{ color: fontColor }}>{afterTermsDescription}</span>
    </>
  );
};

export { CaseTitleWithDeviceLeft };
